<template>
  <div class="formGroup" :data-layout="layout">
    <div class="formGroup__body">
      <formLabel :label="label" :validation="validation" :required="isRequiredLabel"></formLabel>
      <input type="text" style="display: none;" ref="input"
        :name="name"
        :value="generatedValue"
        v-validate:generatedValue="validation"
      >
      <div class="dateInput">
        <select
          class="formControl dateInput__year"
          v-model="year"
          @change="update"
          :data-error="errors.has(name)"
          :data-size="size"
        >
          <option
            v-for="option in years"
            :key="option.value"
            :value="option.value"
          >{{ option.text }}</option>
        </select>
        <select
          class="formControl dateInput__month"
          :data-error="errors.has(name)"
          v-model="month"
          @change="update"
          :data-size="size"
        >
          <option
            v-for="option in months"
            :key="option.value"
            :value="option.value"
          >{{ option.text }}</option>
        </select>
        <select
          class="formControl dateInput__day"
          :data-error="errors.has(name)"
          v-model="day"
          @change="update"
          :data-size="size"
        >
          <option
            v-for="option in days"
            :key="option.value"
            :value="option.value"
          >{{ option.text }}</option>
        </select>
      </div>
    </div>
    <div class="formGroup__footer">
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import mixin from './mixin'

const prependZero = val => (val >= 10 ? `${val}` : `0${val}`)

const createOptions = (len, offset, reverse = false) => {
const options = [{ text: '', value: '' }]
  for (let i = 0; i < len; i++) {
    options.push({
      text: prependZero(i + offset),
      value: prependZero(i + offset)
    })
  }
  return reverse ? options.reverse() : options
}

export default {
  name: 'form-date',
  mixins: [mixin],
  data() {
    return {
      year: '',
      month: '',
      day: ''
    }
  },
  computed: {
    generatedValue() {
      const dateStr = `${this.year}-${this.month}-${this.day}`
      const dateRegex = /[12][0-9]{3}-([1][0-2]|[0][1-9])-(0[1-9]|[12][0-9]|3[01])/
      if (!dateRegex.test(dateStr)) {
        return 'Invalid date'
      }
      return moment(dateStr).format(this.format)
    },
    isRequired() {
      return this.validation ? this.validation.rules.required : false
    },
    days() {
      return createOptions(31, 1)
    },
    months() {
      return createOptions(12, 1)
    },
    years() {
      const diff = Math.abs(moment().diff(moment('1940-01-01'), 'years')) + 1
      return createOptions(diff, 1940)
    }
  },
  props: {
    type: { type: String, default: 'text' },
    format: { type: String, default: 'YYYYMMDD' },
    isBirthday: { type: Boolean, default: false },
    isRequiredLabel: {type: Boolean, default: false}
  },
  created() {
    if (this.value) {
      ;[this.year, this.month, this.day] = [
        this.value.substr(0, 4),
        this.value.substr(4, 2),
        this.value.substr(6, 2)
      ]
    }
    this.onMounted()
  },
  methods: {
    onMounted() {
      this.update()
    },
    update() {
      if (this.generatedValue !== 'Invalid date') {
        this.$emit('input', this.generatedValue)
      }
    }
  }
}</script>

<style lang="scss" scoped>
.dateInput {
  display: flex;
  justifyContent: flex-start;
  align-items: center;
  &__year,
  &__month,
  &__day {
    flex: 0 1 33.33%;
    max-width: 33.33%;
  }
  &__separator {
    display: block;
    line-height: 1;
    margin-left: .5em;
    margin-right: .5em;
  }
  select + select{
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormDate.vue